import {
  Checkmark as CarbonCheckmark,
  Close as CarbonClose
} from '@carbon/icons-react';
import styled from '@emotion/styled';

export const Checkmark = styled(CarbonCheckmark)`
  color: var(--success);
`;

export const Close = styled(CarbonClose)`
  color: var(--error);
`;
